import React from 'react';
import { usePlanogramAutomationContext } from '../../context/PlanogramAutomation';
import * as S from './styles';

const titles = {
    0: {
        title: 'Confirmar produtos',
        subtitle:
            'Confirme os produtos que serão alterados. Se precisar, retorne à pagina anterior para adicionar mais produtos',
    },
    1: {
        title: 'Faça os ajustes necessários',
        subtitle:
            'Clique primeiro em ‘Alterar’ para configurar os ajustes que você deseja realizar',
    },
    2: {
        title: 'Revisão final',
        subtitle:
            'Confira as informações que serão alteradas nos planogramas antes de salvar',
    },
} as const;

type StepKey = keyof typeof titles;

type HeaderPlanogramAutomationProps = {
    title?: string;
    subtitle?: string;
    showSubtitle?: boolean;
};

export const HeaderPlanogramAutomation = ({
    title,
    subtitle,
    showSubtitle = true,
}: HeaderPlanogramAutomationProps) => {
    const { currentStep } = usePlanogramAutomationContext();

    const step = currentStep as StepKey;

    return (
        <S.Header>
            <S.HeaderTitle>{title || titles[step].title}</S.HeaderTitle>
            {showSubtitle && (
                <S.HeaderSubtitle>
                    {subtitle || titles[step].subtitle}
                </S.HeaderSubtitle>
            )}
        </S.Header>
    );
};

export const HeaderPlanogramAutomationArea = ({
    children,
    style,
}: {
    children?: React.ReactNode;
    style?: React.CSSProperties;
}) => {
    return (
        <S.HeaderPlanogramAutomationArea style={style}>
            {children}
        </S.HeaderPlanogramAutomationArea>
    );
};
